<template>
    <tr class="customer-item" v-if="user" @click="showModal = true" style="cursor: pointer">
        <td style="min-width: 300px" :title="(user.first_name ? user.first_name : '') + ' ' + (user.last_name ? user.last_name : '') ">
            <img v-if="user.profile_pic" @error="onFailLoad" :src="user.profile_pic" width="30" height="30" :alt="user.first_name + ' ' + user.last_name" style="border-radius:50%;margin-right: 10px;">
            <img v-else :src="'/static/img/assets/livechat/profile.png'" width="30" height="30" :alt="user.first_name + ' ' + user.last_name" style="border-radius:50%;margin-right: 10px;">
            {{(user.first_name ? user.first_name : '') + ' ' + (user.last_name ? user.last_name : '') | truncate(35)}}
        </td>
        <td class="text-center">
            <span style="color: #3b5998" v-if="user.app == 'facebook'"><i class="fab fa-facebook-square"></i></span>
            <span style="color: #00c300" v-else-if="user.app == 'line'"><i class="fab fa-line"></i></span>
        </td>
        <td>{{user.gender ? user.gender : '-'}}</td>
        
        <td>{{user.registertimestamp ? getFormatDate(user.registertimestamp,'DD/MM/YYYY')  : '-'}}</td>
        <td>{{user.timestamp ? getFormatDate(user.timestamp,'DD/MM/YYYY') : '-'}}</td>
        <td :class="{'background-gray': $store.getters.getPackage != 'premium'}"><customer-item-value :value="user['email']">{{user.email}}</customer-item-value> </td>
        <td :class="{'background-gray': $store.getters.getPackage != 'premium'}"><customer-item-value :value="user['phoneno']">{{user.phoneno}}</customer-item-value></td>
        <td :class="{'background-gray': $store.getters.getPackage != 'premium'}"  class="text-center"><customer-item-value :value="user['status']">{{user.status}}</customer-item-value></td>
        <td :class="{'background-gray': $store.getters.getPackage != 'premium'}"  class="text-center"><customer-item-value :value="user['messagesent']">{{user.messagesent | numberFormat}}</customer-item-value></td>
        <td style="white-space: nowrap;"><template v-if="userLocale"><flag :iso="userLocale.icon" /> {{userLocale.title}}</template> <template v-else> -</template></td>
        <td >
            <a href="javascript:void(0)" class="btn btn-primary transparent btn-sm" style="margin-right: 5px; margin-bottom: 5px;" ><i class="fas fa-align-left"></i> Detail</a>
            <modal-dialog v-if="showModal" @close="showModal = false" style="cursor: auto">
                <div slot="body">
                    <div class="row">
                        <div class="col-sm-4">
                            <img v-if="user.profile_pic" :src="user.profile_pic" alt="" class="img-responsive" style="margin: auto">
                            <br>
                        </div>
                        <div class="col-sm-8">
                            <div class="col-xs-12">
                                <label for="">Fullname</label>
                                <p>{{user.first_name ? user.first_name : ''}} {{user.last_name ? user.last_name : ''}}</p>
                            </div>
                            
                            <div class="col-sm-6">
                                <label for="">Channel</label>
                                <p>
                                    <span style="color: #3b5998" v-if="user.app == 'facebook'"><i class="fab fa-facebook-square"></i> Facebook</span>
                                    <span style="color: #00c300" v-else-if="user.app == 'line'"><i class="fab fa-line"></i> Line</span>
                                </p>
                            </div>
                            
                            <div  class="col-sm-6">
                                <label for="">Gender</label>
                                <p>{{user.gender}}</p>
                            </div>

                            <div  class="col-sm-12">
                                <label for="">Locale</label>
                                <p>
                                    <template v-if="userLocale">
                                    <flag :iso="userLocale.icon" />

                                    {{userLocale.title}}
                                    </template>
                                    <template v-else>
                                        -
                                    </template>
                                </p>
                            </div>

                            <div class="col-xs-12">
                                <hr>
                            </div>
                            <div class="col-sm-6">
                                <label for="">Register Date</label>
                                <p>{{user.registertimestamp ? getFormatDate(user.registertimestamp,'DD/MM/YYYY')  : '-'}}</p>
                            </div>

                            <div class="col-sm-6">
                                <label for="">Last Active Date</label>
                                <p>{{user.timestamp ? getFormatDate(user.timestamp,'DD/MM/YYYY') : '-'}}</p>
                            </div>

                            <div class="col-xs-12">
                                <label for="">Email</label>
                                <p><customer-item-value :value="user['email']">{{user.email}}</customer-item-value> </p>
                            </div>

                            <div class="col-xs-12">
                                <label for="">Phone No.</label>
                                <p><customer-item-value :value="user['phoneno']">{{user.phoneno}}</customer-item-value></p>
                            </div>


                            <div class="col-xs-12">
                                <hr>
                            </div>

                            <div class="col-xs-12">
                                <label>Status</label>
                                <div>
                                    <p><customer-item-value :value="user['status']">{{user.status}}</customer-item-value></p>
                                </div>
                            </div>

                            
                        </div>
                        <div class="col-xs-12">
                            <hr>
                            <div class="col-xs-12">
                                <div>
                                    <label for="">Message Sent</label>
                                    <div style="position: relative" margin-top="25">
                                        <v-premium-plan-popup :showAll="false" v-if="$store.getters.getPackage != 'premium'"></v-premium-plan-popup>
                                        <div style="overflow-y: auto;max-height: 300px;padding: 5px; background: #f7f7f7; border: 1px solid #eee;border-radius: 5px;">
                                            

                                            <template v-if="$store.getters.getPackage != 'premium'">
                                                <div v-for="(intent, index) in 10" :key="'intent_'+ index" style="padding: 10px; margin: 5px 0; border: 1px solid #eee;background: white">
                                                    <div 
                                                        style="height: 15px;position: relative;top: 3px;display: inline-block; width: 100%; max-width: 100px;background-color: #eee"
                                                    ></div>
                                                </div>

                                            </template>
                                            <template v-else>
                                                <template v-if="filterIntent.length > 0">
                                                <div v-for="(intent, index) in filterIntent" :key="'intent_'+ index" style="padding: 10px; margin: 5px 0; border: 1px solid #eee;background: white">
                                                    <template v-if="$store.getters.getPackage == 'premium'">{{intent[0]}} ({{intent[1] | numberFormat}})</template>
                                                    
                                                </div>
                                                </template>
                                                <template v-else>
                                                    <div class="text-center">
                                                        No message sent
                                                    </div>
                                                </template>
                                            </template>

                                        </div>

                                    </div>
                                    <!-- <div class="text-center">
                                        <a href="javascript:void(0);" @click="showAllIntent = true" v-if="!showAllIntent">Show More</a>
                                        <a href="javascript:void(0);" @click="showAllIntent = false" v-else>Collapse</a>
                                    </div> -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div slot="footer">
                    <a href="javascript:void(0);" class="btn btn-default" @click="showModal = false">Close</a>
                </div>
            </modal-dialog>
            <!-- <a href="javascript:void(0)" class="btn btn-primary transparent btn-sm" style="margin-right: 5px; margin-bottom: 5px;"><i class="fab fa-facebook-messenger"></i> Chat</a> -->
        </td>
    </tr>
</template>

<script>
import moment from "moment";
import ModalDialog from '@/components/elements/ModalDialog'
import config from '@/config'
import CustomerItemValue from "./CustomerItemValue"
    export default {
        props: [
            'value'
        ],
        data: function(){
            return {
                user: undefined,
                showModal: false,
                showAllIntent: false
            }
        },
        components: {
            ModalDialog,
            CustomerItemValue
        },
        computed: {
            filterIntent: function(){
                var vm = this
                return vm.user.intentlist.sort(function(a,b){
                    if (parseInt(a[1]) > parseInt(b[1])) {
                        return -1
                    }

                    if (parseInt(a[1]) < parseInt(b[1])) {
                        return 1
                    }

                    return 0
                })
            },
            userLocale: function(){
                var vm = this
                return config.locale.find(function(locale){
                        if(vm.user.locale == locale.value){
                            return locale.title
                        }
                    })
            }
        },
        mounted: function(){
            this.user = this.value
        },
        methods: {
            onFailLoad: function(){
			
                this.$set(this.user, 'profile_pic', '/static/img/assets/livechat/profile.png')
            },
            getFormatDate: function(date, format){
                return moment(date).format(format)
            }
        },
        watch: {
            value: function(){
                this.user = this.value
            }
        }
        
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/view/dashboard/CustomerItem.vue